module.exports = __webpack_public_path__ + "static/media/luminati.be5e72fc.svg";